"use client";

import { ErrorFallback } from "@/components/error-fallback";

/**
 * The last resort: this replaces the root layout when the root layout itself
 * fails, so it must render its own <html> and <body>. It also gets none of the
 * app's global styles, which is why ErrorFallback carries its own.
 *
 * metadata exports are not supported here (error boundaries are Client
 * Components), so the title is React's <title> element.
 */
export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <title>Something went wrong · Rakemori</title>
        <ErrorFallback error={error} retry={retry} />
      </body>
    </html>
  );
}
